export default "__VITE_ASSET__18e2eb8d__"